/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 凭证</li>
 * <li>Version     : 1.0</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
	//五险一金列表
	insureList(params) {
		return Ajax.get("/insure/list", params)
	},
	load(id) {
		return Ajax.get(`/voucher/${id}`)
	},
	loadCode(params) {
		return Ajax.get(`/voucher/code`, params)
	},
	summary() {
		return Ajax.get(`/voucher/summary`)
	},
	delete(id) {
		return Ajax.delete(`/voucher/${id}`)
	},

	edit(params = {}) {
		return Ajax.post(`/insure/edit`, params)
	},
	insureAdd(params = {}) {
		return Ajax.post(`/insure/add`, params)
	},
	//查询员工列表
	stafflist(params) {
		return Ajax.get("/person/list", params)
	},
	//获取部门列表
	department(accountSetsId) {
		return Ajax.get(`/depart/list/${accountSetsId}`)
	},
	//获取证件类型
	cardType() {
		return Ajax.get("/person/cardType")
	},
	//获取学历列表
	education() {
		return Ajax.get("/person/education")
	},
	//编辑员工
	personedit(params = {}) {
		return Ajax.post(`/person/edit`, params)
	},
	//删除员工
	deleteperson(id) {
		return Ajax.post(`/person/del/${id}`)
	},

	//新增员工
	personsave(params = {}) {
		return Ajax.post(`/person/save`, params)
	},

	//新增部门
	adddepartment(params = {}) {
		return Ajax.post(`/depart/save`, params)
	},

	//查询工资列表
	salarylist(params) {
		return Ajax.get("/salary/list", params)
	},
	//查询工资详细信息
	salaryDetails(params) {
		return Ajax.get("/salary/details", params)
	},
	//保存工资单 
	salaryUpdate(params) {
		return Ajax.post("/salary/edit", params)
	},
	//生成工资表
	generateData(params) {
		return Ajax.get(`/salary/generate`,params)
	},
	//获取工资表时间List
	salarydateList(accountSetsId) {
		return Ajax.get(`/salary/dateList/${accountSetsId}`)
	},
	//获取工资统计项
	getcollect(params) {
		return Ajax.get("/salary/collect", params)
	},
	//获取自定义模板
	gettemplate(params) {
		return Ajax.get("/salary/template/get", params)
	},
	//保存自定义模板
	savetemplate(params) {
		return Ajax.post("/salary/template/save", params)
	},
}
